import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=4dd61575&scoped=true&"
import script from "./Holidays.vue?vue&type=script&lang=js&"
export * from "./Holidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd61575",
  null
  
)

export default component.exports